export default __webpack_public_path__ + "static/media/_IMG4863.eac27e72.jpg";